/**
 * @fileOverview The main entry point to your standalone. Start editing here.
 */

import React, { Suspense, useState, useRef, useEffect } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/reset.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/site.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/segment.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/container.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/header.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/image.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/list.css'
import './styles.scss'
import { Map } from 'components/map'
import { Candidates } from 'components/candidates'
import { Masthead } from '@ta-interaktiv/react-masthead'
import { Footer } from '@ta-interaktiv/react-footer'
import { ThemeSwitch } from '@ta-interaktiv/react-theme-switch'
import Scrollchor from 'react-scrollchor'
import { ChipsArray } from 'components/chipsArray'
import { PortraitPicture } from 'components/portraitPicture'
import { Link } from '@ta-interaktiv/contentbricks'
import Button from '@material-ui/core/Button'
import ListIcon from '@material-ui/icons/List'
import { DataGrid } from '@material-ui/data-grid'
import { Autocomplete } from '@material-ui/lab'
import { TextField } from '@material-ui/core'
import { CSSTransition } from 'react-transition-group'
import PersonIcon from '@material-ui/icons/Person'
import { ArticleTeasers } from '@ta-interaktiv/react-article-teasers'
import GetSheetDone from 'get-sheet-done'
import RotateLeftIcon from '@material-ui/icons/RotateLeft'
import { frFR } from '@material-ui/core/locale'
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles'
import csvjson from 'csvjson'

import domainesProDataVqh from '../../data/domaines-professionnels.csv'
// import candidatsDataVqh from '../../data/candidats-data-vqh.csv'
// import communesDataVqh from '../../data/communes-data-vqh.csv'
import communes from '../../data/communes.csv'

const ARTICLE_ID = '456774297450'

export function AppComponent() {
  const [filteredCandidates, setFilteredCandidates] = useState([])
  const [municipalityCandidates, setMunicipalityCandidates] = useState([])
  const isMobile = window.innerWidth < 600
  const [
    filteredMunicipalityCandidates,
    setFilteredMunicipalityCandidates
  ] = useState([])
  const [chips, setChips] = useState(['01', '11'])
  const [selectedMunicipality, setSelectedMunicipality] = useState(null)
  const [selectedCandidate, setSelectedCandidate] = useState(null)
  const [communesCandidatesData, setCommunesCandidatesData] = useState([])
  const [showCandidatesList, setShowCandidatesList] = useState(false)
  const [linkedStories, setLinkedStories] = useState([])
  const [communesDataVqh, setCommunesDataVqh] = useState([])
  const [candidats, setCandidats] = useState([])

  const gotoCommuneInfos = useRef(null)
  const gotoFilteredList = useRef(null)
  const urlParams = new URLSearchParams(window.location.search)
  const isEmbed = urlParams.get('embed')
  const defautlMunicipality = urlParams.get('id')
  const defaultMunicipaliyName = defautlMunicipality
    ? communes.find(c => c.code === defautlMunicipality).nom
    : null

  const theme = createMuiTheme(
    {
      palette: {
        primary: { main: '#1976d2' }
      }
    },
    frFR
  )

  const handleMunicipalityChange = (e, v) => {
    e.preventDefault()
    setSelectedMunicipality(v)
    setMunicipalityCandidates(candidats.filter(c => c.commune_id === v.code))
    setTimeout(() => {
      gotoCommuneInfos.current.simulateClick()
    }, 200)
  }

  const autocompleteProps = {
    className: 'commune-selection',
    options: communes,
    getOptionLabel: option => option.nom,
    onChange: handleMunicipalityChange,
    renderInput: params => (
      <TextField {...params} label='Commune' variant='outlined' />
    ),
    autoSelect: true,
    blurOnSelect: true,
    disableClearable: true,
    noOptionsText: 'Aucune commune avec ce nom'
  }

  const handleChips = chips => {
    console.log('FIlTER')
    console.log(chips)
    // Filter the candidates according the user preferences
    const candidatesSlice = candidats.filter(c =>
      chips.every(e => c.filters.includes(e))
    )

    // Count how many filtered candidates per municipality
    const candidatesFilteredCount = candidatesSlice.reduce((acc, cur) => {
      acc[cur.commune_id] = acc[cur.commune_id] + 1 || 1
      return acc
    }, {})

    // Count how many candidates per municipality
    const candidatesCount = candidats.reduce((acc, cur) => {
      acc[cur.commune_id] = acc[cur.commune_id] + 1 || 1
      return acc
    }, {})

    // Find the percentages and create the final array
    const mapData = Object.entries(candidatesFilteredCount).reduce((a, b) => {
      const cdata = communesDataVqh.find(c => c.id === b[0])
      const ccount = candidatesCount[b[0]]

      return [
        ...a,
        {
          id: b[0],
          count: b[1],
          pct: b[1] / ccount
        }
      ]
    }, [])

    setChips(chips)
    setFilteredCandidates(chips.length > 0 ? candidatesSlice : null)
    selectedMunicipality &&
      setFilteredMunicipalityCandidates(
        chips.length > 0
          ? candidatesSlice.filter(
              c => c.commune_id === selectedMunicipality.code
            )
          : null
      )

    console.log('Result - all')
    console.log(candidatesSlice)
    if (selectedMunicipality) {
      console.log('Result', '-', selectedMunicipality.nom)

      console.log(
        chips.length > 0
          ? candidatesSlice.filter(
              c => c.commune_id === selectedMunicipality.code
            )
          : null
      )
    }

    setCommunesCandidatesData(mapData)
  }

  const getData = () => {
    // Get the communes Data
    window
      .fetch(
        `https://interactif.24heures.ch/2021/elections-communales-vaudoises-resultats/data/communes-data-vqh.csv?nocache=${new Date().getTime()}`
      )
      .then(response => {
        return response.text()
      })
      .then(csv => {
        setCommunesDataVqh(csvjson.toObject(csv, { quote: '"' }))
      })

    // Get the candidates Data
    window
      .fetch(
        `https://interactif.24heures.ch/2021/elections-communales-vaudoises-resultats/data/candidats-data-vqh.csv?nocache=${new Date().getTime()}`
      )
      .then(response => {
        return response.text()
      })
      .then(csv => {
        const cd = csvjson.toObject(csv, { quote: '"' })
        // transform the comma separated filters string into an array
        const c =
          cd.length > 0
            ? cd.reduce(
                (a, b) => [
                  ...a,
                  {
                    ...b,
                    filters: b.filters.split(',')
                  }
                ],
                []
              )
            : []
        setCandidats(c)
        // Check if we have a municipality in the URL and update the
        // states if it is the case
        if (defautlMunicipality) {
          setMunicipalityCandidates(
            c.filter(c => c.commune_id === defautlMunicipality)
          )
        }
      })
  }

  useEffect(() => {
    if (chips.length > 0) {
      handleChips(chips)
    }
  }, [selectedMunicipality])

  useEffect(() => {
    // Get the latest candidates and communes data
    getData()

    /* setInterval(() => {
      console.log('Tick')
      getData()
    }, 60000) */

    // Get the related stories
    GetSheetDone.labeledCols(
      '15Pvus82UIvJy6AfsQbLX6McOFti4xIV5Nxdyhwk0-KQ',
      1
    ).then(sheet => {
      setLinkedStories(sheet.data.filter(s => s['publié'] === 'TRUE'))
      console.log(sheet.data.filter(s => s['publié'] === 'TRUE'))
    })

    // Check if we have a municipality in the URL and update the
    // states if it is the case
    if (defautlMunicipality) {
      setSelectedMunicipality(
        communes.find(c => c.code === defautlMunicipality)
      )
      setMunicipalityCandidates(
        candidats.filter(c => c.commune_id === defautlMunicipality)
      )
    }
  }, [])

  const links = selectedMunicipality
    ? linkedStories
        .filter(
          s => s.commune === '' || s.idcommune === selectedMunicipality.code
        )
        .sort((a, b) =>
          !a.commune ? 1 : !b.commune ? -1 : a.commune.localeCompare(b.commune)
        )
        .reduce((a, b) => [...a, b.idarticle], [])
    : linkedStories
        .filter(s => s.commune === '')
        .reduce((a, b) => [...a, b.idarticle], [])

  const columns = isMobile
    ? [
        {
          field: 'fullName',
          headerName: 'Nom',
          description: 'This column has a value getter and is not sortable.',
          sortable: true,
          flex: 1,
          valueGetter: params =>
            `${params.getValue('nom') || ''} ${params.getValue('prénom') || ''}`
        },
        {
          field: 'commune',
          headerName: 'Commune',
          flex: 1
        }
      ]
    : [
        {
          field: 'fullName',
          headerName: 'Nom',
          description: 'This column has a value getter and is not sortable.',
          sortable: true,
          flex: 1,
          valueGetter: params =>
            `${params.getValue('nom') || ''} ${params.getValue('prénom') || ''}`
        },
        {
          field: 'âge',
          headerName: 'Age',
          flex: 1
        },
        {
          field: 'commune',
          headerName: 'Commune',
          flex: 1
        }
      ]

  return (
    <div className={`index${isEmbed ? ' embed' : ''}`}>
      {!isEmbed && <Masthead articleId={ARTICLE_ID} />}

      <ThemeSwitch />

      {!isEmbed && (
        <header className='ui vertical  very fitted  segment'>
          <div className='ui container'>
            <div className='ui header'>
              {!defautlMunicipality || !selectedMunicipality ? (
                <h1>Les élus à la Municipalité de votre commune</h1>
              ) : (
                <h1>
                  Les élus à la Municipalité d
                  {['a', 'e', 'i', 'o', 'u', 'y'].includes(
                    selectedMunicipality.nom
                      .charAt(0)
                      .normalize('NFD')
                      .replace(/[\u0300-\u036f]/g, '')
                      .toLowerCase()
                  )
                    ? "'"
                    : 'e '}
                  {selectedMunicipality.nom}
                </h1>
              )}
              <h2>
                Découvrez tous les résultats des élections aux Municipalités,
                commune par commune. Trouvez un candidat parmi les listes
                officielles ou partez à la recherche du{' '}
                <Link href='846053390522'>profil idéal</Link> avec l'aide de
                notre base de données.
              </h2>
              <div className='ta author'>
                Mathieu Rudaz, Mathieu Signorell, Léa Favre
              </div>
            </div>
          </div>
        </header>
      )}

      {/* <div className='ui text container'>
        <p className='ui ta text'>
          Le 7 mars prochain auront lieu, comme tous les cinq ans, les élections
          générales dans les communes vaudoises. La municipalité et le syndic
          seront élus à l'occasion de ce rendez-vous démocratique majeur.
        </p>
        <p className='ui ta text'>
          Nous avons compilé l'ensemble des listes obtenues auprès des
          autorités. Ces informations, parfois acquises avec difficulté, nous
          permettent de dresser le portrait des habitants qui souhaitent se
          mettre au service de leur commune.
        </p>
  </div> */}

      {!isEmbed && !defautlMunicipality && (
        <div className='find-candidates-container'>
          <div
            className={`ui vertical grey segment ${
              selectedMunicipality ? 'minimized' : ''
            }`}
            style={{ paddingTop: '5em', zIndex: 1, paddingBottom: '4em' }}
            id='find-candidates'
          >
            <Scrollchor
              ref={gotoCommuneInfos}
              to='#commune-infos'
              disableHistory
            />
            <div className='ui center aligned text container'>
              <h4 className='ui header dark'>Trouvez les résultats</h4>
              <div
                className='ui very fitted vertical segment'
                style={{ padding: 0 }}
              >
                <Autocomplete {...autocompleteProps} />
              </div>
            </div>
            <div
              className='ui text container center aligned'
              style={{ paddingTop: '0.75em' }}
            >
              <small>
                Ou explorez notre{' '}
                <Link href='846053390522'>base de données</Link>
              </small>
            </div>
          </div>
        </div>
      )}
      <Suspense fallback={<div>Chargement</div>}>
        <Candidates
          municipalities={communesDataVqh}
          municipality={selectedMunicipality}
          candidates={municipalityCandidates}
          handleSelectCandidate={candidate => {
            document.body.classList.add('disable_scroll')
            setSelectedCandidate(candidate)
          }}
        />
      </Suspense>
      {isEmbed && (
        <div className='ui text container'>
          <Link href='456774297450'>
            Tous les résultats, commune par commune
          </Link>
          <Link href='846053390522'>
            Tous les candidats aux Municipalités vaudoises
          </Link>
        </div>
      )}

      {!isEmbed && defautlMunicipality && (
        <div className='find-candidates-container'>
          <div
            className={`ui vertical grey segment ${
              selectedMunicipality ? 'minimized' : ''
            }`}
            style={{ paddingTop: '5em', zIndex: 1, paddingBottom: '4em' }}
            id='find-candidates'
          >
            <Scrollchor
              ref={gotoCommuneInfos}
              to='#commune-infos'
              disableHistory
            />
            <div className='ui center aligned text container'>
              <h4 className='ui header dark'>Trouvez les résultats</h4>
              <div
                className='ui very fitted vertical segment'
                style={{ padding: 0 }}
              >
                <Autocomplete {...autocompleteProps} />
              </div>
            </div>
            <div
              className='ui text container center aligned'
              style={{ paddingTop: '0.75em' }}
            >
              <small>
                Ou explorez notre base de données{' '}
                <i className='ui icon chevron down' />
              </small>
            </div>
          </div>
        </div>
      )}

      {!isEmbed && (
        <>
          <PortraitView
            selectedCandidate={selectedCandidate}
            handleFindOthers={() => {
              console.log('CLICK')
              console.log(selectedCandidate)
              handleChips(selectedCandidate.filters)
            }}
            handleClose={() => {
              setSelectedCandidate(null)
              document.body.classList.remove('disable_scroll')
            }}
          />

          <div className='ui vertical segment'>
            <div className='ui container'>
              <h4 className='ui header'>Plus d'articles sur ce thème</h4>
              <ArticleTeasers numberOfCards='three' articleIds={links} />
            </div>
          </div>

          <Footer
            title='Comment jugez-vous ce contenu?'
            questions={[
              'Était-il informatif?',
              'La mise en oeuvre a-t-elle fonctionné?',
              'La mise en forme vous plaît-elle?'
            ]}
            mailTo='mathieu.rudaz@24heures.ch'
            locale='fr'
            hidePortfolioTeaser
            articleId={ARTICLE_ID}
            credits={[
              ['Conception et réalisation', 'Mathieu Rudaz'],
              ['Coordination', 'Léa Favre'],
              [
                'Saisie des données',
                'Léa Favre, Mathieu Signorell, Richard, Max, Charlotte, Luca et Léonie'
              ],
              [
                'Photos',
                "Brigitte Besson pour les portraits de Victoria Thibaud, Yves Jauner et Piéric Freiburghaus, Gaia Baur pour le portrait de Jean Christophe Schwaab, Adrien Clerc pour le portrait de Clerc Etienne et Yann Rod pour les candidats à la municipalité d'Yvonand à l'exception du portrait de Mme Frensau"
              ]
            ]}
          />
        </>
      )}
    </div>
  )
}

const PortraitView = ({ selectedCandidate, handleClose, handleFindOthers }) => {
  const gotoProfiler = useRef(null)
  const todayYear = new Date().getFullYear()

  return (
    <>
      <Scrollchor ref={gotoProfiler} to='#candidates-profiler' disableHistory />
      <CSSTransition
        unmountOnExit
        in={!!selectedCandidate}
        timeout={200}
        classNames='portrait-view-container'
      >
        <div className='portrait-view-container'>
          <div
            className='dimmer'
            onClick={() => {
              handleClose()
            }}
          />
          <div
            className='portrait-view'
            onClick={() => {
              handleClose()
            }}
          >
            {selectedCandidate && (
              <>
                <div className='candidate-info-panel'>
                  <div className='portrait-header center aligned'>
                    <PortraitPicture
                      id={selectedCandidate.id}
                      genre={selectedCandidate.genre}
                    />
                    <div>
                      <b>
                        {selectedCandidate['prénom']} {selectedCandidate.nom}
                      </b>
                    </div>
                    <div>
                      {selectedCandidate['âge'] !== ''
                        ? `${selectedCandidate['âge']} ans`
                        : 'Na pas voulu'}
                    </div>
                  </div>
                  <div className='portrait-content'>
                    <div>
                      <b>{selectedCandidate.observation}</b>
                    </div>
                    <div>{selectedCandidate.profession}</div>
                    {selectedCandidate.liste !== '' && (
                      <div className='liste'>
                        <b>Liste</b> {selectedCandidate.liste}
                      </div>
                    )}
                    {selectedCandidate.sortant && (
                      <div style={{ paddingBottom: '2em' }}>
                        <RotateLeftIcon
                          style={{ color: '#202346', fontSize: '1em' }}
                        />
                        Se représente. À la municipalité depuis{' '}
                        <b>{todayYear - selectedCandidate.sortant}</b>
                        &nbsp;ans.
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </CSSTransition>
    </>
  )
}
